<template>
    <v-dialog v-model="dialog" scrollable max-width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn elevation="0" v-bind="attrs" v-on="on">
                <v-icon left>
                    mdi-account-plus
                </v-icon> 
                {{ $t('components.CreateSingleCustomer.DialogButtonLabel') }}
            </v-btn>
        </template>
        <v-card>
            <v-card-title>{{ $t('components.CreateSingleCustomer.DialogTitleText') }}</v-card-title>
            <v-divider/>
            <v-card-text style="max-height: 600px;">
                <CustomerForm @submit="createCustomer"/>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-btn elevation="0" text @click="dialog = false">
                    {{ $t('components.CreateSingleCustomer.DialogCancelButtonLabel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EventBus from '@/utils/EventBus';
import CustomersAPI from '@/utils/CustomersAPI';

import CustomerForm from '@/components/customers/CustomerForm';

/**
 * CreateSingleCustomer includes the required function and imports the 
 * CustomerForm component to include the required fields to perform the creation
 * of a new single customer. It uses CustomersAPI class to create the customer.
 */
export default {
    name: 'CreateSingleCustomer',
    data: () => ({
        dialog: false,
        rules: {
            required: value => !!value || 'Required.',
            requiredList: value => (!!value && value.length > 0) || 'Required.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            }
        }
    }),
    methods: {
        async createCustomer(customer) {
            let message;
            try {
                const { name, email, clinics, report, app_version } = customer;
                const [ success, result ] = await CustomersAPI.createCustomer(name, email, clinics, report, app_version);

                if (success) this.$emit('created');
                message = success ? `Customer '${name}' (${email}) created succesfully.` : result;
            } catch (e) {
                message = e;
            }

            this.dialog = false;
            EventBus.$emit('popup', message);
        }
    },
    components: { CustomerForm }
}
</script>